import * as Url from "./urls";

import React, { useEffect, useState } from "react";

import Axios from "axios";

export const getRakTransactionList = (request = {}, headers = {}, params = {}) => {
  return Axios.post(Url.getRakTransactionList, request, {
    headers: headers,
    params: params,
  });
};
// export const getAllRegistrationList = (
//   request = {},
//   headers = {},
//   params = {}
// ) => {
//   return Axios.post(Url.getRegistrationList, request, {
//     headers: headers,
//     params: params,
//   });
// };
export const getAllUpdatedList = (request = {}, headers = {}, params = {}) => {
  return Axios.post(Url.getUpdatedList, request, {
    headers: headers,
    params: params,
  });
};
export const getAllRejectedList = (request = {}, headers = {}, params = {}) => {
  return Axios.post(Url.getRejectedList, request, {
    headers: headers,
    params: params,
  });
};
// export const RegistrationDetails = (id) => {
//   return Axios.get(Url.getVerificationList + id);
// };

export const getUpdates = (setUpdations, setUpdatesStatus) => {
  let updates = [];

  const body = JSON.stringify({
    page: 1,
    size: 10,
  });

  fetch(Url.updates, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: body,
  }).then(function (response) {
    if (response.status == "200") {
      // flag=true;
      return response.json();
    } else {
    }
  });
};

export const getAllRejection = (
  setDataLoading,
  searchBy,
  searchByValue,
  fromDate,
  toDate,
  setRejected
) => {};
